/**
 * Real-world [lng, lat] for Get Directions links.
 * Image-map mode: `location` is normalized map coords — use `directions` only.
 * Mapbox mode: fall back to `location` when `directions` is empty (legacy).
 * @param {object} poi
 * @param {string} [mapDisplayMode] tour.mapbox.mapDisplayMode
 * @returns {[number, number]|null}
 */
export function getDirectionsCoordsForPopup(poi, mapDisplayMode) {
  if (!poi) return null;
  let directions = poi.directions;
  if (typeof directions === "string") {
    try {
      directions = JSON.parse(directions);
    } catch {
      directions = null;
    }
  }
  if (Array.isArray(directions) && directions.length >= 2) {
    return [directions[0], directions[1]];
  }
  if (mapDisplayMode === "image") {
    return null;
  }
  let { location } = poi;
  if (typeof location === "string") {
    try {
      location = JSON.parse(location);
    } catch {
      return null;
    }
  }
  if (Array.isArray(location) && location.length >= 2) {
    return [location[0], location[1]];
  }
  return null;
}
